const inappropriateWords = [
  // English profanity
  "fuck",
  "shit",
  "bitch",
  "bastard",
  "ass",
  "asshole",
  "damn",
  "crap",
  "dick",
  "pussy",
  "cock",
  "slut",
  "whore",
  "piss",
  "bollocks",

  // Singlish/Local slang (offensive)
  "cheebye",
  "chee bye",
  "lan jiao",
  "lanjiao",
  "pukimak",
  "puki mak",
  "kanina",
  "nabei",
  "nabeh",
  "nia bu",
  "nee na bu",
  "smlj",
  "walao eh",
  "siao",
  "gila",

  // Hokkien offensive terms
  "lao kwee",
  "kao peh",
  "gao peh",

  // Malay offensive terms
  "bodoh",
  "sial",
  "pantat",
  "kepala buto",
  "celaka",

  // Chinese romanized (offensive)
  "cao ni ma",
  "caonima",
  "ta ma de",
  "tamade",
  "sha bi",
  "shabi",
  "ni ma",
  "nima",
  "qu si",
  "qusi",

  // Racial slurs (must be filtered)
  "negro",
  "nigger",
  "chink",
  "gook",
  "keling",
  "ah neh",

  // Sexual content
  "porn",
  "nude",
  "naked",
  "boobs",
  "tits",

  // Common abbreviations (without special characters)
  "wtf",
  "stfu",
  "knn",
  "ccb",
  "nbcb",
  "lpg",
  "kkj",
  "tmd",
  "tml",
  "fck",
  "fuk",
];

export const checkMessage = (text) => {
  if (!text || text.trim() === "") return [];

  const lowerText = text.toLowerCase().trim();
  const foundWords = [];

  inappropriateWords.forEach((badWord) => {
    const pattern =
      "\\b" + badWord.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&") + "\\b";
    const regex = new RegExp(pattern, "i");

    if (regex.test(lowerText)) {
      foundWords.push(badWord);
    }
  });

  return foundWords;
};
